import { createFileRoute } from "@tanstack/react-router";
import BcbsokInsurance, { config } from "@/pages/BcbsokInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/bcbsok-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "BCBS Oklahoma TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Blue Cross Blue Shield Oklahoma coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "BCBS Oklahoma TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Blue Cross Blue Shield Oklahoma coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/bcbsok-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/bcbsok-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BcbsokInsurance />;
}
